// ABOUTME: SPEC-82 D-8 — a positive "this browser has had the intro film on screen" record, read
// ABOUTME: only under skip_intro_film/tap_to_talk, so flag-off tenants never touch the key.

// Separate from `versai_seen_intro`: that record cannot tell "watched the film" from "skipped it".
export const FILM_PLAYED_KEY = 'versai_film_played';
export const FILM_PLAYED_VERSION = 1;

/** True when a well-formed record exists. Never throws (Safari private mode throws on getItem). */
export function hasPlayedFilm() {
  try {
    const raw = localStorage.getItem(FILM_PLAYED_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    return !!parsed && typeof parsed === 'object' && parsed.v === FILM_PLAYED_VERSION
      && typeof parsed.ts === 'number' && Number.isFinite(parsed.ts);
  } catch {
    return false;
  }
}

/** Idempotent; a failed write just means the next frame says `film_played:false` again. */
export function markFilmPlayed(now = Date.now) {
  if (hasPlayedFilm()) return;
  try {
    localStorage.setItem(FILM_PLAYED_KEY, JSON.stringify({ v: FILM_PLAYED_VERSION, ts: now() }));
  } catch {
    /* storage unavailable: nothing to remember it in */
  }
}
